import {
  ActionIcon,
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import { useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { createLinkedinMessage } from "../../../../api/ModelsApi";
import { IconCheck, IconCloudUpload, IconUpload } from "@tabler/icons-react";
import BackButton from "../../../../components/View/BackButton";
import { createFile } from "../../../../api/FIleAPI";
import { FileUploader } from "react-drag-drop-files";

const LinkedinVoiceFile = ({ handleClose, onCreated }) => {
  const lang = useLanguage((s) => s.language);
  const [name, setName] = useState("");
  const [voiceFile, setVoiceFile] = useState(null);
  const [invalidFile, setInvalidFile] = useState(false);
  const [filesKey, setFilesKey] = useState(false);
  const [dragging, setDragging] = useState(false);

  const handleGetFile = (newFile) => {
    setVoiceFile(newFile);
    setFilesKey(!filesKey);
    setInvalidFile(false);

    let newName = newFile.name.split(".");
    newName.pop();
    setName(newName.join("."));
  };

  const filePickerStyles = useMemo(() => {
    if (invalidFile) {
      return {
        border: "2px dashed",
        boxShadow: "#c00 0 0 8px",
        borderColor: "#cc0000",
        borderRadius: 8,
        padding: 8,
        textAlign: "center",
        cursor: "pointer",
      };
    } else
      return {
        border: "1px solid var(--mantine-color-primary-3)",
        borderRadius: 16,
        borderStyle: "dashed",
        padding: 2,
        textAlign: "center",
        cursor: "pointer",
      };
  }, [invalidFile]);

  const [submitting, setSubmitting] = useState(false);
  const onSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    const extension = voiceFile.name.split(".").pop();

    // 2. On récupère le vrai type MIME (fallback sur audio/mpeg au cas où)
    const mimeType = voiceFile.blob?.type || voiceFile.type || "audio/mpeg";

    // 3. On crée le fichier avec la bonne extension et le bon type
    let f = new File(
      [voiceFile.blob || voiceFile],
      `saved_audio.${extension}`,
      {
        type: mimeType,
      },
    );

    setSubmitting(true);
    createFile({
      file: f,
      name: data.name,
    }).then((res) => {
      createLinkedinMessage({
        name: data.name,
        sender: data?.sender,
        file_id: res.data.file_id,
        text: "",
      })
        .then((r) => {
          handleClose();
          onCreated(r?.data?.model_id);
        })
        .finally(() => setSubmitting(false));
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <LoadingOverlay visible={submitting} />

      <FileUploader
        handleChange={handleGetFile}
        key={filesKey}
        name="file"
        types={["WAV", "MP3"]}
        hoverTitle={lang.components.files.drop_here}
        onDraggingStateChange={(d) => {
          setDragging(d);
        }}
        required={!voiceFile}
        multiple={false}
      >
        <Stack
          align="center"
          gap={"xs"}
          mih={300}
          py={32}
          justify="center"
          style={filePickerStyles}
        >
          <ThemeIcon size={48}>
            <IconCloudUpload size={64} />
          </ThemeIcon>
          <Text style={{ opacity: dragging ? 0.1 : 1 }}>
            {lang.components.files.drag_drop_here}
          </Text>
          {voiceFile ? (
            <>
              <Text fw={600} c={"tertiary.8"}>
                {lang.files.create.dialog.selected}:
              </Text>
              <Text key={voiceFile.lastModified} fw={600} c={"tertiary.8"}>
                {voiceFile?.name}
              </Text>
            </>
          ) : (
            <Text fw={600} c={"red"}>
              {lang.files.create.dialog.no_file}
            </Text>
          )}
          <Text ta="center" size="sm" c={"dimmed"} mt={"md"}>
            ( WAV / MP3 )
          </Text>
        </Stack>
      </FileUploader>

      {voiceFile && (
        <TextInput
          name="name"
          label={lang.files.create.dialog.name}
          placeholder={lang.files.create.dialog.name}
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          mt={"sm"}
          size="md"
        />
      )}
      <Group justify="space-between" mt={24}>
        <BackButton
          onClick={handleClose}
          label={lang.model_smv.smv_editor.dialog.close}
          size="md"
        />
        <Button
          leftSection={<IconCheck />}
          disabled={!voiceFile}
          size="md"
          type="submit"
        >
          {lang.model_smv.smv_editor.dialog.use}
        </Button>
      </Group>
    </form>
  );
};

export default LinkedinVoiceFile;
